import React from 'react';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CartPageWrapper } from '../../../cart/CartPageWrapper';

export const Cart = () => {
    const { t } = useTranslation('cart', {
        keyPrefix: 'CART',
    });

    return (
        <div>
            <div>
                <PageTitle>{t('TITLE')}</PageTitle>
                <Typography sx={{ paddingY: '20px' }}>
                    {t('CART_NOTE')}
                </Typography>
            </div>
            <CartPageWrapper />
        </div>
    );
};
